import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CampaignChange } from '../models/campaignChange';

@Injectable({ providedIn: 'root' })
export class CampaignChangeService {
  constructor(private http: HttpClient) {}

  // Audit trail for one campaign, newest first.
  getChanges(campaignId: string): Observable<CampaignChange[]> {
    const url = `${environment.apiUrl}campaigns/${campaignId}/changes`;
    return this.http.get<CampaignChange[]>(url);
  }
}
